import { DataValidator, IsString, Required, transformKeys } from "@/utils/type-vaildator";
import api, { apiV2 } from "./api";

// 视频直接生成数字人 请求参数
export interface VideoToDigitalHumanRequest {
  user_id?: string;
  actor_name: string;
  actor_video: string;
  audio_name: string;
  sample_audio_url: string;
}

// 视频直接生成数字人 请求参数
export interface VideoToDigitalHumanProps {
  userId?: string;
  actorName: string;
  actorVideo: string;
  audioName: string;
  sampleAudioUrl: string;
}

// 视频直接生成数字人 响应参数
export interface VideoToDigitalHumanResponse {
  message: string;
  status: string;
  template_id: string;
}

export class VideoToDigitalHumanData {
  @Required("message cannot be empty")
  @IsString("message must be a string")
  message: string;

  @Required("status cannot be empty")
  @IsString("status must be a string")
  status: string;

  @Required("templateId cannot be empty")
  @IsString("templateId must be a string")
  templateId: string;
}

const transformAndValidateData = (
  response: VideoToDigitalHumanResponse
): VideoToDigitalHumanData => {
  const transformedData = transformKeys(response);

  try {
    const mainData = DataValidator.validateOrThrow(
      transformedData,
      VideoToDigitalHumanData
    );
    return mainData;
  } catch (error) {
    console.error("VideoToDigitalHuman data validation failed:", error.message);
    throw error;
  }
};

/** 视频直接生成数字人 */
export const videoToDigitalHuman = async (props: VideoToDigitalHumanProps) => {
  const params: VideoToDigitalHumanRequest = {
    user_id: props.userId,
    actor_name: props.actorName,
    actor_video: props.actorVideo,
    audio_name: props.audioName,
    sample_audio_url: props.sampleAudioUrl,
  };
  const res = await apiV2.post<VideoToDigitalHumanResponse>('/video/direct-huozu-training', params);
  return transformAndValidateData(res.data);
}
